module.exports = __webpack_public_path__ + "img/popup_btn_get.86806206.png";